var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [{ name: "sticky-header", rawName: "v-sticky-header" }],
      attrs: {
        stripe: "",
        fit: "",
        "highlight-current-row": "",
        data: _vm.list,
        "header-cell-class-name": "table-header-cell",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          label: "序号",
          width: "60",
          align: "center",
          type: "index",
          "class-name": "table-header-cell",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(scope.$index + 1 + (_vm.pageIndex - 1) * _vm.limit)
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "商品名称",
          prop: "goodsName",
          "min-width": "150",
          "class-name": "name-col",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: "商品图片",
          prop: "cover",
          width: "100",
          "class-name": "image-col",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("el-image", {
                  attrs: {
                    src: row.cover,
                    "preview-src-list": [row.cover],
                    lazy: "",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "商品分类", width: "100", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "div",
                  { staticClass: "flex-tag" },
                  [
                    row.categoryName
                      ? _c("el-tag", { attrs: { effect: "plain" } }, [
                          _vm._v(_vm._s(row.categoryName)),
                        ])
                      : _vm._e(),
                    row.section
                      ? _vm._l(row.sections, function (section, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              attrs: {
                                type: _vm._f("tagType")(section),
                                effect: "dark",
                              },
                            },
                            [_vm._v(_vm._s(_vm._f("activateZone")(section)))]
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "进价和成本", width: "120" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("p", [
                  _c("span", { staticClass: "bold" }, [_vm._v("供货价：")]),
                  _vm._v(_vm._s(_vm._f("filterPrice")(row.stockPrice))),
                ]),
                _c("p", [
                  _c("span", { staticClass: "bold" }, [_vm._v("成本价：")]),
                  _vm._v(_vm._s(_vm._f("filterPrice")(row.costPrice))),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm.mall === "premium"
        ? [
            _c("el-table-column", {
              attrs: {
                label: "零售价",
                prop: "retailPrice",
                width: "80",
                align: "right",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.retailPrice))),
                      ]
                    },
                  },
                ],
                null,
                false,
                4245218337
              ),
            }),
            _c("el-table-column", {
              attrs: {
                label: "惊喜倍数",
                prop: "surprise",
                width: "80",
                align: "center",
              },
            }),
          ]
        : _vm.mall === "welfare"
        ? [
            _c("el-table-column", {
              attrs: {
                label: "零售价",
                prop: "retailPrice",
                width: "80",
                align: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _vm._v(_vm._s(_vm._f("filterPrice")(row.retailPrice))),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "售价", prop: "point", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("p", [
                        _c("span", { staticClass: "bold" }, [_vm._v("现金：")]),
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.pointPrice))),
                      ]),
                      _c("p", [
                        _c("span", { staticClass: "bold" }, [_vm._v("积分：")]),
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.point))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "惊喜倍数",
                prop: "surprise",
                width: "80",
                align: "center",
              },
            }),
          ]
        : _vm.mall === "point"
        ? [
            _c("el-table-column", {
              attrs: {
                label: "兑换积分",
                prop: "point",
                width: "100",
                align: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [_vm._v(_vm._s(_vm._f("filterInteger")(row.point)))]
                  },
                },
              ]),
            }),
          ]
        : _vm._e(),
      _c("el-table-column", {
        attrs: { label: "库存", prop: "quantity", width: "80", align: "right" },
      }),
      _c("el-table-column", {
        attrs: { label: "排序", prop: "sortBy", width: "80", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { label: "状态", width: "120", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "div",
                  { staticClass: "flex-switch" },
                  [
                    _vm._v(" 新品："),
                    _c("el-switch", {
                      staticClass: "rectangle md",
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function ($event) {
                          return _vm.handleUpdate(row, "isNew")
                        },
                      },
                      model: {
                        value: row.isNew,
                        callback: function ($$v) {
                          _vm.$set(row, "isNew", $$v)
                        },
                        expression: "row.isNew",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex-switch" },
                  [
                    _vm._v(" 推荐："),
                    _c("el-switch", {
                      staticClass: "rectangle md",
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function ($event) {
                          return _vm.handleUpdate(row, "isHot")
                        },
                      },
                      model: {
                        value: row.isHot,
                        callback: function ($$v) {
                          _vm.$set(row, "isHot", $$v)
                        },
                        expression: "row.isHot",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex-switch" },
                  [
                    _vm._v(" 上架："),
                    _c("el-switch", {
                      staticClass: "rectangle md",
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function ($event) {
                          return _vm.handleUpdate(row, "isOnsale")
                        },
                      },
                      model: {
                        value: row.isOnsale,
                        callback: function ($$v) {
                          _vm.$set(row, "isOnsale", $$v)
                        },
                        expression: "row.isOnsale",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "操作", align: "center", width: "100", fixed: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleEdit(row.id)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleRemove(row.id)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }